// extracted by mini-css-extract-plugin
export default {"statement-condition":"Statement_statement-condition__EO4E7","statement-operator":"Statement_statement-operator__l0Sca"};